export interface ChatUiPalette {
  canvasBg: string;
  sidebarBg: string;
  sidebarText: string;
  sidebarMutedText: string;
  sidebarBorder: string;
  sidebarCardBg: string;
  sidebarCardActiveBg: string;
  sidebarCardHoverBg: string;
  headerBg: string;
  headerText: string;
  chatAreaBg: string;
  chatAreaText: string;
  chatAreaMutedText: string;
  overlay: string;
  accent: string;
  accentContrast: string;
  questionInputBg: string;
  questionInputText: string;
  questionInputPlaceholder: string;
  questionInputBorder: string;
  questionInputShadow: string;
  answerBubbleBg: string;
  answerBubbleText: string;
  answerBubbleBorder: string;
  answerBubbleShadow: string;
  userBubbleBg: string;
  userBubbleText: string;
  userBubbleBorder: string;
  actionButtonBg: string;
  actionButtonText: string;
  actionButtonBorder: string;
  actionButtonHoverBg: string;
  hintCardBg: string;
  hintCardText: string;
  errorText: string;
}

export const CHAT_UI_PALETTE: ChatUiPalette = {
  canvasBg: 'var(--cockpit-canvas)',
  sidebarBg: 'var(--cockpit-sidebar)',
  sidebarText: 'var(--cockpit-text)',
  sidebarMutedText: 'var(--cockpit-text-muted)',
  sidebarBorder: 'var(--cockpit-border)',
  sidebarCardBg: 'transparent',
  sidebarCardActiveBg: 'var(--cockpit-sidebar-active)',
  sidebarCardHoverBg: 'var(--cockpit-sidebar-active)',
  headerBg: 'var(--cockpit-canvas)',
  headerText: 'var(--cockpit-text)',
  chatAreaBg: 'var(--cockpit-canvas)',
  chatAreaText: 'var(--cockpit-text)',
  chatAreaMutedText: 'var(--cockpit-text-muted)',
  overlay: 'var(--cockpit-overlay)',
  accent: 'var(--cockpit-accent)',
  accentContrast: 'var(--cockpit-accent-contrast)',
  questionInputBg: 'var(--cockpit-surface-soft)',
  questionInputText: 'var(--cockpit-text)',
  questionInputPlaceholder:
    'color-mix(in srgb, var(--cockpit-text-muted) 80%, var(--cockpit-surface-soft))',
  questionInputBorder: 'transparent',
  questionInputShadow: 'none',
  answerBubbleBg: 'var(--cockpit-surface-strong)',
  answerBubbleText: 'var(--cockpit-text)',
  answerBubbleBorder: 'transparent',
  answerBubbleShadow: 'none',
  userBubbleBg: 'var(--cockpit-surface-soft)',
  userBubbleText: 'var(--cockpit-text)',
  userBubbleBorder: 'transparent',
  actionButtonBg: 'var(--cockpit-surface)',
  actionButtonText: 'var(--cockpit-text)',
  actionButtonBorder: 'var(--cockpit-border)',
  actionButtonHoverBg: 'var(--cockpit-sidebar-active)',
  hintCardBg: 'var(--cockpit-surface-soft)',
  hintCardText: 'var(--cockpit-text)',
  errorText: 'var(--cockpit-danger)'
};

export const chatUiAlpha = (color: string, opacity: number): string => {
  if (color.trim().startsWith('var(')) {
    return `color-mix(in srgb, ${color} ${opacity * 100}%, transparent)`;
  }

  return alpha(color, opacity);
};
import { alpha } from '@mui/material';
